import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';
import { Empresa } from '../api';

@Injectable({
  providedIn: 'root'
})
export class EmpresaSectorService {
  private readonly path = 'profissionais';
  public params = new HttpParams();

  constructor(private apiService: ApiService) { }

  // List all empresa do sector
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: Empresa[] }>(`${this.path}/getAllEmpresa`, params ? new HttpParams({
      fromObject: params
    }) : this.params, 
    true // <- força o uso da URL secundária
    ).pipe(
      map(response => response)
    );
  }

  // Get all representants of empresa do sector
  public getRepresentantes(id: string, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.apiService.get<{ data: any[] }>(
      `${this.path}/getAllRepresentacaoEmpresa?id=${id}&page=${page}&pageSize=${pageSize}`, new HttpParams(),
      true // <- força o uso da URL secundária
    );
  }  

  // Get Empresa by ID
  public show(id: string): Observable<Empresa> {
    return this.apiService.get<{ data: Empresa }>(`${this.path}/getEmpresaById/${id}`,
      new HttpParams(),
      true // URL secundária
    ).pipe(
      map(response => response.data as Empresa)
    );
  }

  /**
   * Create a new Empresa
   * @param formData FormData containing new Empresa data
   * @returns Observable<any>
   */
  public store(formData: FormData): Observable<any> {
    return this.apiService.post(
      `/AddEmpresa`,
      formData,
      undefined,
      true // URL secundária
    );
  }

  // Create new Empresa do sector
  public storeWithLogo(formData: FormData): Observable<any> {
    return this.apiService.post<any>(
      `${this.path}/AddEmpresa`,
      formData,
      {},
      true // true = usa a URL secundária
    );
  }  

  // Update existing Empresa do sector
  public update(formData: FormData, id: string): Observable<any> {
    return this.apiService.put(`${this.path}/UpdateEmpresa/`, formData,
      undefined,
      true // URL secundária
    )
  }

  // Delete existing Empresa do sector
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteEmpresaById/${id}`,
      new HttpParams(),
      true // URL secundária
    );
  }

  /**
   * Activar Empresa by ID - PATCH endpoint
   * @param id Empresa ID
   * @returns Observable<any>
   */
  public ativarEmpresa(id: string): Observable<any> {
    return this.apiService.patch(
      `${this.path}/AtivarEmpresaById/${id}`,
      {},
      true // URL secundária
    );
  }

  /**
   * Desativar Empresa by ID - PATCH endpoint
   * @param id Empresa ID
   * @returns Observable<any>
   */
  public desativarEmpresa(id: string): Observable<any> {
    return this.apiService.patch(
      `${this.path}/DesativarEmpresaById/${id}`,
      {},
      true // URL secundária
    );
  }

  // Add photo Empresa do sector
  public addEmpresaPhoto(formData: FormData) {
    return this.apiService.post(`${this.path}/AddPhotoEmpresa`, formData,
      {},
      true // URL secundária
    );
  }

  // get photo Empresa do sector
  getPhotoEmpresaIdGet(id: number): Observable<Blob> {
    return this.apiService.get(`${this.path}/getPhotoEmpresa/${id}`,
      new HttpParams(),
      true,
      'blob',
    );
  }
}